import charts from '../charts.js';
import graphs, * as graphOptions from './technicals/graphs.js';
import panels from './technicals/panels.js';

export default function({ id, data, config, dates, defaults, earningsData }) {
	const isChartsSection = window.config.url && window.config.url.data[0]=='analyze' && window.config.url.data[1]=='charts';
	const settings = {
		data,
		legend: { },
		scrollbar: {
			series: {
				valueYField: 'close',
			},
		},
		yAxis: {
			numberFormat: "#.#a",
		},
		xAxis: {
			baseInterval: charts.groupings.daily[0],
			groupIntervals: charts.groupings.daily,
			groupCount: 366,
			groupData: true,
		},
	};

	if (charts.groupings.hasOwnProperty(defaults.periodGrouping)) {
		settings.xAxis.groupIntervals = charts.groupings[ defaults.periodGrouping ];
	}

	const chart = charts.draw(id, settings, dates);

	if( isChartsSection ) {
		chart.setPrefixesForYAxis({
			bigNumberPrefixes: charts.bigNumberPrefixes,
			smallNumberPrefixes: [],
		});
	}

	defaults.defaultOverlays.unshift(defaults.defaultSeries, 'open', 'close', 'high', 'low');

	chart.toggleOverlay = function(value, active, colour = false) {
		for (const graph of Object.keys(graphs)) {
			if (graph.startsWith(`${value}_`) || graph === value) {
				if (!active) {
					chart.removeSeries(graph);
					continue;
				}

				const graphSettings = graphs[ graph ];

				if (graph.startsWith('EMA') || graph.startsWith('SMA')) {
					graphSettings.stroke = colour ? colour : graphOptions.nextColour();
				}

				chart.addSeries(
					chart[ graphSettings.type ](graphSettings)
				);
			}
		}
	}

	chart.toggleIndicator = function(value, active) {
		for (const indicator of Object.keys(panels)) {
			if (indicator !== value) {
				continue;
			}

			if (!active) {
				chart.removePanel(indicator);
				continue;
			}

			const panelSettings = panels[ indicator ];

			const { panel, yAxis, xAxis } = chart.addPanel(panelSettings.panel, panelSettings.yAxis, settings.xAxis);

			for (const series of panelSettings.series) {
				chart.addSeries(
					chart[ series.type ](series, yAxis, xAxis),
					panel
				);
			}
		}
	}

	for (const key of _.uniq(defaults.defaultOverlays)) {
		chart.toggleOverlay(key, true);
	}

	for (const key of _.uniq(defaults.defaultIndicators)) {
		chart.toggleIndicator(key, true);
	}

	chart.addEarnings();

	return chart;
};
